const ProfileData = {
  img: require("../assets/Images/hero.png"),
  logo: require("../assets/Images/Name.png"),
  name: "Om Bhaltilak",
  professions: [
    "Generative AI Developer",
    "Agentic AI Systems Engineer",
    "LLM Orchestration & RAG Architect",
    "OCI 2025 Certified AI Professional",
    "B.Tech — AI & Data Science, AISSMS IOIT"
  ],
  info: [
"I build end-to-end Generative AI systems — designing autonomous multi-agent workflows, LLM pipelines, and intelligent retrieval architectures that reason and act with minimal human intervention.",
"Proficient in LangChain, Python, FAISS, and ChromaDB — engineering scalable Agentic AI solutions and cloud-native deployments on Azure and Oracle Cloud Infrastructure that are efficient and production-ready.",
  ],
  resume: "https://github.com/ombhaltilak/Resume", 
};

export default ProfileData;